import React from 'react';
import { Link } from 'react-router-dom';
import { quizAPI } from '../services/api';
import useApi from '../hooks/useApi';

const QuizList = () => {
    const { data: quizzes, loading, error } = useApi(quizAPI.getQuizzes);

    if (loading) {
        return (
            <div className="container mt-5">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger" role="alert">
                    Error loading quizzes: {error.message}
                </div>
            </div>
        );
    }

    return (
        <div className="container mt-5">
            <h1>Available Quizzes</h1>
            <div className="row mt-4">
                {quizzes?.map((quiz) => (
                    <div key={quiz.id} className="col-md-4 mb-4">
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">{quiz.title}</h5>
                                <p className="card-text">{quiz.description}</p>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="badge bg-primary">
                                        {quiz.questions?.length || 0} Questions
                                    </span>
                                    <Link to={`/quiz/${quiz.id}`} className="btn btn-primary">
                                        Start Quiz
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuizList; 